module.exports = __webpack_public_path__ + "img/insights.612e03b3.svg";